// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import titleMixin from './util/title'
import metaMixin from './util/meta'
import canonicalMixin from './util/canonical'
import VueLazyload from 'vue-lazyload'

Vue.config.productionTip = false

Vue.mixin(titleMixin)
Vue.mixin(metaMixin)
Vue.mixin(canonicalMixin)

Vue.use(VueLazyload)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
})

Vue.use(VueLazyload, {
  preLoad: 1.3,
  attempt: 1,
})



// WEBPACK FOOTER //
// ./src/main.js